import { OverlayContainer } from "@kalyzee/kalyzee-ui";
import { useMeetingSelector } from "@kalyzee/kast-web-sdk";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useAppStoreContext } from "../../contexts/appStore/context";
import { useMeetingUtilsContext } from "../../contexts/meetingUtils/context";
import { useSdkContext } from "../../contexts/sdk/context";
import { isExpert } from "../../helpers/roles";
import { useExperimentalFeatures } from "../../hooks/experimental";
import { HighlightedUserListWorkBox } from "../workBoxes/list/HighlightedUserListWorkBox";
import { useOuterClick } from "@kalyzee/kast-web-sdk/web-components";

export const HighlightPopup = React.memo(({ 
}: {
}) => {
  const { populated, containerAPI } = useMeetingUtilsContext();
  const sdkCtx = useSdkContext();

  const [session] = useMeetingSelector(containerAPI, "session");
  const expFeatures = useExperimentalFeatures();  

  const [showHighlightPopup, setShowHighlightPopup] = useState(populated.highlighted.requesting.length > 0);

  const highlightRequestsPopupDivRef = useRef<HTMLDivElement>(null);

  const seenRequests = useRef(new Set<string>());

  const storeCtx = useAppStoreContext();

  useOuterClick(highlightRequestsPopupDivRef, () => {
    setShowHighlightPopup(false);
  });

  useEffect(() => {
    if (populated.highlighted.requesting.length === 0) {
      setShowHighlightPopup(false);
    }
  }, [populated.highlighted.requesting.length === 0])

  useEffect(() => {
    const newRequests = new Set<string>();
    populated.highlighted.requesting.forEach(s => {
      newRequests.add(s.id);
    });

    // check if there is some requests that were not in the previous seen
    
    let hasNewRequests = false;
    newRequests.forEach(id => {
      if (!seenRequests.current.has(id)) hasNewRequests = true;
    });
    if (hasNewRequests) {
      // Do not show popup if wb mode is already on highlight
      if (storeCtx.getState().workBoxMode !== "highlight") {
        setShowHighlightPopup(true);
      }
    }

    seenRequests.current = newRequests;
  }, [populated.highlighted.requesting, storeCtx]);

  const enabledSections = useMemo(() => ({
    requesting: true,
  }), []);

  const onClose = useCallback(() => {
    setShowHighlightPopup(false);
  }, []);

  if (!isExpert(session)) return null;
  if (!showHighlightPopup) return null;
  if (!expFeatures.board) return null;

  return (
    <OverlayContainer
      style={{
        width: "100%",
        height: "100%",
        position: "absolute",
        zIndex: 10,
      }}
      overlay={
        <div
          ref={highlightRequestsPopupDivRef}
          style={{
            width: "min(90%, 600px)",
            height: "min(90%, 900px)",
          }}
        >
          <HighlightedUserListWorkBox
            sdk={sdkCtx}
            highlightSessions={populated.highlighted}
            enabledSections={enabledSections}
            foldableSections={false}
            onClose={onClose}
          />
        </div>
      }
    />
  );
});